var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavMenuXsvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9445 8.6903C27.5278 8.27361 26.8514 8.27361 26.4347 8.6903L8.31739 26.8076C7.90069 27.2243 7.90069 27.9007 8.31739 28.3174C8.73409 28.7341 9.41047 28.7341 9.82716 28.3174L27.9445 10.2001C28.3612 9.78338 28.3612 9.107 27.9445 8.6903Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28027 10.8042L22.365 23.8889C22.7817 24.3056 23.4581 24.3056 23.8748 23.8889C24.2915 23.4722 24.2915 22.7959 23.8748 22.3792L10.79 9.29444C10.3733 8.87774 9.69697 8.87774 9.28027 9.29444C8.86357 9.71114 8.86357 10.3875 9.28027 10.8042Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3917 26.8939C28.8084 27.3106 28.8084 27.9869 28.3917 28.4036C27.975 28.8203 27.2986 28.8203 26.8819 28.4036L17.8232 19.345C17.4065 18.9283 17.4065 18.2519 17.8232 17.8352C18.2399 17.4185 18.9163 17.4185 19.333 17.8352L28.3917 26.8939Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMenuXsvg);
export default __webpack_public_path__ + "static/media/nav-MenuXSVG.c6327ccbf7cdd9a7ce097023efc4c257.svg";
export { ForwardRef as ReactComponent };